import { Button } from '@hqo/react-components-library/dist/atoms/button';
import styled from 'styled-components';

interface AddingVisitorsBlockContainerProps {
  $hasVisibleVisitors?: boolean;
}

export const AddingVisitorsBlockContainer = styled.div<AddingVisitorsBlockContainerProps>`
  display: flex;
  align-items: flex-start;
  justify-content: center;
  flex-direction: column;
  width: 100%;
  margin-bottom: 12px;

  @media (min-width: 768px) {
    ${({ $hasVisibleVisitors }) =>
      $hasVisibleVisitors &&
      `
        height: 350px;
        overflow-y: auto;
        overflow-x: hidden;
        flex-shrink: 0;
        justify-content: flex-start;
      `}
  }
`;

export const Title = styled.div`
  font: 500 16px / normal ${({ theme }) => theme.fonts.join()};
  color: ${({ theme }) => theme.colors.palette.systemBlack};
`;

export const Subtitle = styled.div`
  font: 400 14px / normal ${({ theme }) => theme.fonts.join()};
  color: ${({ theme }) => theme.colors.palette.systemBlack};
  margin-bottom: 12px;
`;

export const AddGuestButton = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  border-radius: 8px;
  background-color: transparent;
  color: ${({ theme }) => theme.colors.$primary};
  cursor: pointer;
  font: 500 14px / normal ${({ theme }) => theme.fonts.join()};

  &:focus {
    outline: none;
    box-shadow: 0 0 0 2px ${({ theme }) => theme.colors.$primary}40;
  }
`;

export const StyledButton = styled(Button)`
  color: ${({ theme }) => theme.colors.$secondary};
  font-weight: 500;
  margin-left: -16px;

  &:hover:not([disabled]) {
    color: ${({ theme }) => theme.colors.$secondary};
  }

  &:focus:not([disabled]) {
    color: ${({ theme }) => theme.colors.$secondary};
  }

  & button {
    &:hover:not([disabled]) {
      color: ${({ theme }) => theme.colors.$secondary};
    }
  }
`;
